export class User {
    id: number;
    userName: string;
    userPassword: string;
    name: string;
    isActive: boolean;
    createDate: Date;
    email: string;
}
